module.exports = __webpack_public_path__ + "assets/img/home_auth.3a7d6d06.png";